export const config = {
    api_base: 'https://prod.diningtek.com/api/v1',
    api_root : 'https://prod.diningtek.com',
    api_account : 'https://account.diningtek.com',
    //api_root: 'https://testapi.diningtek.biz/api',
    token : localStorage.getItem("access_token"),
    user_id:localStorage.getItem("user_email"),
    mid:localStorage.getItem("mid"),
    permissionType: localStorage.getItem("permission_type")
};
